import React from 'react'
import { t, Trans } from '@lingui/macro'

import { ItemList } from '../../components/common/list/ItemList'
import SurveyItem from './SurveyItem'
import { ISurvey } from './types'
import './Surveys.less'
import IconEmptyGroup from 'public/assets/img/empty-group.svg'

const SurveysList = ({ surveys }) => {
  if (surveys.length === 0) {
    return (
      <div className="no-items">
        <img src={IconEmptyGroup} alt={t`Empty group`} />
        <h2>
          <Trans>No surveys yet?</Trans>
        </h2>
        <h4>
          <Trans>Collect user insights by creating and sending surveys</Trans>
        </h4>
      </div>
    )
  }

  return (
    <ItemList
      items={surveys}
      itemsCount={surveys.length}
      renderItem={(survey: ISurvey) => <SurveyItem survey={survey} />}
    />
  )
}

export default SurveysList
